import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditService } from '../base';
import {
  ProductBillOfMaterial,
  ProductPurchaseOrderHistory,
  ProductSalesOrderHistory,
  StockEnquiryByProduct,
  StockEnquiryDetails,
  StockEnquiryProductHistory,
  StockEnquiryPurchaseContract,
  StockEnquirySalesContract,
  StockEnquirySummary,
  StockEnquirySummaryTop,
  StockItemProductEnquiry,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class StockEnquiryService extends TmsWebBaseEditService<StockEnquiryByProduct, StockEnquiryDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('StockEnquiry', $localize`Stock Enquiry`);
  }

  getStockEnquiryHistory(id: string): Observable<StockEnquiryProductHistory[]> {
    return this.httpService.get<StockEnquiryProductHistory[]>(`${this.apiUrl}/StockEnquiryHistory/${id}`);
  }

  getStockEnquiryOldEdit(id: string): Observable<StockEnquiryByProduct> {
    return this.httpService.get<StockEnquiryByProduct>(`${this.apiUrl}/OldEdit/${id}`);
  }

  getStockEnquirySalesOrderHistory(id: string, search: string): Observable<ProductSalesOrderHistory[]> {
    return this.httpService.get<ProductSalesOrderHistory[]>(
      `${this.apiUrl}/StockEnquirySalesOrderHistory?id=${id}&search=${search}`,
    );
  }

  getStockEnquirySalesOrderHistoryCustomer(id: string, customerId: string): Observable<ProductSalesOrderHistory[]> {
    return this.httpService.get<ProductSalesOrderHistory[]>(
      `${this.apiUrl}/StockEnquirySalesOrderHistoryCustomer?id=${id}&customerId=${customerId}`,
    );
  }

  getStockEnquirySummaryTop(id: string): Observable<StockEnquirySummaryTop> {
    return this.httpService.get<StockEnquirySummaryTop>(`${this.apiUrl}/GetSummaryTop?id=${id}`);
  }

  getSummary(id: string): Observable<StockEnquirySummary> {
    return this.httpService.get<StockEnquirySummary>(`${this.apiUrl}/Summary/${id}`);
  }

  getStockEnquiryPurchaseOrderHistory(id: string, search: string): Observable<ProductPurchaseOrderHistory[]> {
    return this.httpService.get<ProductPurchaseOrderHistory[]>(
      `${this.apiUrl}/StockEnquiryPurchaseOrderHistory?id=${id}&search=${search}`,
    );
  }

  getStockEnquiryPurchaseContracts(id: string): Observable<StockEnquiryPurchaseContract[]> {
    return this.httpService.get<StockEnquiryPurchaseContract[]>(`${this.apiUrl}/StockEnquiryPurchaseContract?id=${id}`);
  }

  getStockEnquirySalesContracts(id: string): Observable<StockEnquirySalesContract[]> {
    return this.httpService.get<StockEnquirySalesContract[]>(`${this.apiUrl}/StockEnquirySalesContract?id=${id}`);
  }

  getStockEnquiryForBillOfMaterials(id: string): Observable<ProductBillOfMaterial[]> {
    return this.httpService.get<ProductBillOfMaterial[]>(`${this.apiUrl}/StockEnquiryForBillOfMaterials/${id}`);
  }

  getStockItemsForProduct(id: string, includeAll: boolean): Observable<StockItemProductEnquiry[]> {
    return this.httpService.get<StockItemProductEnquiry[]>(
      `${this.apiUrl}/StockItemsForProduct?id=${id}&includeAll=${includeAll}`,
    );
  }
}
